import Alpine from "alpinejs";
import * as UI from "../framework/ui";

Alpine.data("notifications", ({ tab, trainingSessionId }) => ({
  tab: tab,
  loading: true,
  limit: 5,
  load() {
    this.loading = true;
    const basicUrl = p`/ajax/notifications?limit=${this.limit}`;
    const url = this.tab == "ts" ? basicUrl + `&training_session_id=${trainingSessionId}` : basicUrl;
    UI.swap({
      url,
      container: this.$refs.content,
    }).then(() => (this.loading = false));
  },
  seeMore() {
    // Maximum number of notifications will be set by the backend
    this.limit = null;
    this.load();
  },
}));
